import { render, staticRenderFns } from "./unboxevent.vue?vue&type=template&id=4a993014&"
import script from "./unboxevent.vue?vue&type=script&lang=js&"
export * from "./unboxevent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports